module.exports = __webpack_public_path__ + "sastifaction auteurs.jpg?2f71676746cdad740254fe8efbc06784";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sastifaction auteurs.jpg
// module id = 196
// module chunks = 0